import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import { NonAppCrewCard } from 'Containers/People/PeopleTabs/NonAppCrewTab';
import { LetterHeader } from 'Components/People/PeopleTabs/LetterHeader/LetterHeader';

interface Props {
  crewInitials: any[];
  selectCardClick: (crew: any) => void;
}

const NonAppCrew = ({ crewInitials, selectCardClick }: Props) => (
  <>
    {crewInitials.length > 0 &&
      crewInitials.map(({ initial, crew }: any) => (
        <LetterHeader key={initial} name={initial}>
          {crew.map((member: any) => (
            <NonAppCrewCard key={member.id} crew={member} onClickCrewCard={selectCardClick} />
          ))}
        </LetterHeader>
      ))}
  </>
);

const NonAppCrewMemo = memo(NonAppCrew, areEqual);

export { NonAppCrewMemo as NonAppCrew };
